<template>
  <div class="page">
    <!-- <Tabstop :topListindex="3"></Tabstop> -->

    <div class="page-img-swiper">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/img/app/banner.png" alt="" srcset="" />
          </div>
        </div>
        <!-- 如果需要分页器 注释下方html结构 -->
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div id="system_appjj" class="commom-title-box">
      <div class="title-top">旭牧通APP</div>
      <div class="title-background">Mobile Client</div>
    </div>

    <div ref="jzwmAmiBox" class="page-qxpp-box">
      <div class="page-qxpp-width">
        <img src="./../assets/img/app/app1.png" alt="" />
      </div>
      <div class="page-qxpp-felx">
        <div class="felx-title">APP简介</div>

        <div
          v-show="jzwmShow"
          class="felx-content animate__animated animate__backInRight"
        >
        旭牧通特色数字化平台致力于为畜牧业解决技术诊疗难题、提供优质产品和增值服务的宗旨，围绕自身成熟的产品链、供应链、前置仓、会员库体系来解决畜牧生产发展过程中所遇到的难题和瓶颈，通过构建一个技术共享、产品共享、信息共享、金融共享、买卖共享的数字化综合服务平台，力争养殖户增收，畜牧业增效，破解“三农”困局，助推数字乡村建设，实现畜牧养殖生态一体化。
        </div>
      </div>
    </div>

    <div id="system_sgwr" class="commom-title-box">
      <div class="title-top">四个围绕</div>
      <div class="title-background">Four Surrounds</div>
    </div>

    <div class="page-zbzc-c-box">
      <div ref="zbzcAmiBox" class="page-zbzc-elrow">
        <div class="zbzc-c-list">
          <div
            v-show="zbzcShow"
            class="zbzc-c-list-item animate__animated animate__fadeInDown"
          >
            <div class="zbzc-c-title">产品链</div>
            <img src="./../assets/img/app/si1.png" alt="" />
            <div class="zbzc-c-desc">整合厂商、精选优品、产销直供</div>
          </div>
        </div>

        <div class="zbzc-c-list">
          <div
            v-show="zbzcShow"
            class="zbzc-c-list-item animate__animated animate__fadeInDown"
          >
            <div class="zbzc-c-title">供应链</div>
            <img
             
              src="./../assets/img/app/si2.png"
              alt=""
            />
            <div class="zbzc-c-desc">品牌营销、仓储物流、上下赋能</div>
          </div>
        </div>

        <div class="zbzc-c-list">
          <div
            v-show="zbzcShow"
            class="zbzc-c-list-item animate__animated animate__fadeInDown"
          >
            <div class="zbzc-c-title">前置仓</div>
            <img
           
              src="./../assets/img/app/si3.png"
              alt=""
            />
            <div class="zbzc-c-desc">电销地推、技术指导、定制服务</div>
          </div>
        </div>

        <div class="zbzc-c-list">
          <div
            v-show="zbzcShow"
            class="zbzc-c-list-item animate__animated animate__fadeInDown"
          >
            <div class="zbzc-c-title">会员库</div>
            <img
           
              src="./../assets/img/app/si4.png"
              alt=""
            />
            <div class="zbzc-c-desc">福利促销、粘性升级、基数裂变</div>
          </div>
        </div>
      </div>
    </div>

    <div id="system_wdgx" class="commom-title-box">
      <div class="title-top">五个共享</div>
      <div class="title-background">Five Shares</div>
    </div>

    <div class="page-cjwt-box">
      <img src="./../assets/img/app/wdgx.png" alt="">
      <!-- <div class="page-cjwt-list" v-for="(item, index) in funData" :key="index">
        <div class="back">
          <div class="cjwt-center">{{ item.ques }}</div>
        </div>
      </div> -->
    </div>

    <div id="system_cpzs" class="commom-title-box">
      <div class="title-top">数字化产品展示</div>
      <div class="title-background">Digital Product Display</div>
    </div>

    <div class="page-zhanshi-box">
      <el-row :gutter="90" class="zhanshi-two-list">
        <el-col :span="12" class="zhanshi-lsit">
          <div class="zhanshi-lsit-item">
            <img src="./../assets/img/app/zs1.png" alt="" />
            <div class="zhanshi-bottm">
              <div class="zhanshi-bottm-title">旭牧通用户端</div>
              <div class="zhanshi-bottm-desc">
                优质特惠产品共享，贴心服务一键即达<br />免费专业问诊服务，疑难杂症不再迷路
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="zhanshi-lsit">
          <div class="zhanshi-lsit-item">
            <img
              style="width: 374px; height: 454px"
              src="./../assets/img/app/zs2.png"
              alt=""
            />
            <div class="zhanshi-bottm">
              <div class="zhanshi-bottm-title">站长业务端</div>
              <div class="zhanshi-bottm-desc">
                店铺管理实时把控，订单查账有迹可循<br />商品采购方便快捷，数据呈现精准明晰
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="90" class="zhanshi-two-list">
        <el-col :span="12" class="zhanshi-lsit">
          <div class="zhanshi-lsit-item">
            <img src="./../assets/img/app/zs3.png" alt="" />
            <div class="zhanshi-bottm">
              <div class="zhanshi-bottm-title">电销业务端</div>
              <div class="zhanshi-bottm-desc">
                线上店铺极速整合，商品订单高效处理<br />客户信息优化管理，业务资源全面掌握
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="zhanshi-lsit">
          <div class="zhanshi-lsit-item">
            <img
              style="width: 374px; height: 454px"
              src="./../assets/img/app/zs4.png"
              alt=""
            />
            <div class="zhanshi-bottm">
              <div class="zhanshi-bottm-title">旭牧通技术端</div>
              <div class="zhanshi-bottm-desc">
                资深专家团队在线，视频诊疗极速指导<br />签到打卡智能管理，在线办公简洁高效
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="ht-box">
        <div class="ht-img">
          <img src="./../assets/img/app/zs5.png" alt="" />
        </div>

        <div class="ht-right">
          <div class="ht-title">后台管理端</div>

          <div class="ht-desc">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;旭牧通销售管理后台，设置待办事项、快速导航、日数据分析、销量统计功能，便于每日工作业绩统计分析，提高效率。<br />

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;商品列表管理中，各产品的归属、分类、价格、规格以及上架状态等详情可随时跟进查看，便于分析产品去库存进度，进而调整产品营销策略，促进销售。
          </div>
        </div>
      </div>
    </div>

    <div id="system_smxz" class="commom-title-box">
      <div class="title-top">扫码下载APP</div>
      <div class="title-background">Scan Code To Download</div>
    </div>

    <div class="page-smxz-box">
      <el-row :gutter="90">
        <el-col :span="12">
          <img src="./../assets/img/app/xia1.png" alt="" />
          <div class="smxz-bottm-desc">扫码下载旭牧通APP</div>
        </el-col>

        <el-col :span="12">
          <img src="./../assets/img/app/xia2.png" alt="" />
          <div class="smxz-bottm-desc">扫码关注公众号</div>
        </el-col>
      </el-row>
    </div>

    <PageBottom></PageBottom>
  </div>
</template>

<script>
export default {
  name: "promotion",
  data() {
    return {
      jzwmShow: true,
      zbzcShow: false,
      funData: [
        { ques: "技术共享——为养殖户提供免费技术诊疗服务" },
        { ques: "产品共享——为养殖户提供优质的产品服务" },
        { ques: "信息共享——让养殖户跳出知识盲区" },
        { ques: "金融共享——成就更多养殖户创业梦想" },
        { ques: "买卖共享——为养殖行业零散商户提供买卖平台" },
      ],
      form: {},
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    if (this.$route.query.scid) {
      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo({
            top: document.getElementById(this.$route.query.scid).offsetTop - 81,
            behavior: "smooth",
          });
        }, 100);
      });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    var mySwiper = new Swiper(".swiper-container", {
      loop: true, // 循环模式选项 用于轮播图的切换
      speed: 500, // 轮播图 消失到出现 切换的时间
      autoplay: {
        delay: 3000, // 轮播图 在多长时间后显示下一张图片；
        disableOnInteraction: false,
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
  created() {},
  methods: {
    handleScroll() {
      //滚动函数
      let _this = this;
      let refArray = [
        { ref: "jzwmAmiBox", show: "jzwmShow" },
        { ref: "zbzcAmiBox", show: "zbzcShow" },
      ];
      refArray.forEach((r) => {
        _this.gdjz(r.ref, 20, () => {
          _this[r.show] = true;
        });
      });
    },
    gdjz(div, offset, callback) {
      let dom = this.$refs[div]; // 等同于document.querySelector('.earth') true
      if (dom) {
        var a, b, c, d;
        d = dom.offsetTop; // 元素距离相对父级的高度，这里父级指的是body
        a = eval(d + offset);
        b =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; //  获取窗口滚动条高度
        c = document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
        if (b + c > a) {
          callback && callback();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.page-img-swiper {
  width: 100%;
  /* height: 600px; */
}

.swiper-container {
  width: 100%;
  /* height: 600px; */
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  // height: 100%;
  /* object-fit: cover; */
}

.page-qxpp-box {
  width: calc(100% - 560px);
  margin: 0 auto;
  height: 420px;

  display: flex;
  .page-qxpp-width {
    width: 474px;
    height: 342px;
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      transition: all 0.5s;
    }
    img:hover {
      transform: scale(1.2);
    }
  }
  .page-qxpp-felx {
    flex: 1;
    padding: 40px 20px 0px 60px;

    .felx-title {
      height: 33px;
      font-size: 24px;
      font-family: Noto Sans S Chinese;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
      margin-bottom: 20px;
    }
    .felx-content {
      width: 100%;
      line-height: 35px;
      font-size: 16px;
      font-family: Noto Sans S Chinese;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      text-align: justify;
      text-justify: distribute;
    }
  }
}

.page-cjwt-box {
  width: 100%;
  // width: 1380px;
  // margin: 20px auto;
  // margin-bottom: 80px;

  img{
    width: 100%;
  }

  .page-cjwt-list {
    width: 1380px;
    position: relative;
    line-height: 66px;
    text-align: center;
    margin-bottom: 20px;
    background: #f5f8fe;
    color: #333333;

    .cjwt-center {
      width: 100%;
      display: inline-block;
      flex: 1;
      font-size: 17px;
      font-weight: 400;
    }
  }

  .page-cjwt-list:nth-child(odd) {
    background: #3a7dd8;
    color: #fff;
  }
}

.page-zbzc-c-box {
  width: 100%;
  padding: 0 280px;
  margin-bottom: 40px;
  height: 400px;
  .page-zbzc-elrow {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .zbzc-c-list {
    width: calc(25% - 60px);
  }

  .zbzc-c-list-item {
    height: 400px;
    background: #f5f8fe;
    text-align: center;

    img {
      width: 79px;
      height: 79px;
    }

    .zbzc-c-title {
      padding-top: 60px;
      padding-bottom: 50px;
      font-size: 24px;
      font-family: Noto Sans S Chinese;
      font-weight: 400;
      color: #333333;
    }

    .zbzc-c-desc {
      padding-top: 10px;
      padding: 60px 10px 0 10px;
      font-size: 16px;
      font-family: Noto Sans S Chinese;
      font-weight: 400;
      color: #333333;
    }
  }
}

.page-zhanshi-box {
  width: calc(100% - 600px);
  margin: 0 auto;

  .zhanshi-two-list {
    width: 100%;
    position: relative;
    margin-bottom: 90px;

    &::before {
      content: " ";
      position: absolute;
      left: 10%;
      bottom: -20px;
      width: 80%;
      height: 0px;
      border: 1px dashed #ccc;
    }
  }

  .zhanshi-lsit-item {
    width: 100%;
    margin-bottom: 30px;

    text-align: center;
    img {
      display: inline-block;
      width: 391px;
      height: 453px;
    }

    .zhanshi-bottm-title {
      position: relative;
      display: inline-block;
      width: 200px;
      margin-bottom: 40px;
      font-size: 21px;
      font-weight: 600;

      &::before {
        content: " ";
        position: absolute;
        left: 83px;
        bottom: -20px;
        width: 34px;
        height: 2px;
        background: #333333;
        border: 1px solid #333333;
        border-radius: 2px;
      }
    }

    .zhanshi-bottm-desc {
      margin-bottom: 30px;
      font-size: 16px;
      font-weight: 400;
      line-height: 35px;
    }
  }

  .ht-box {
    display: flex;
    .ht-img {
      width: 671px;
      height: 362px;

      img {
        width: 671px;
        height: 362px;
      }
    }

    .ht-right {
      flex: 1;
      padding-left: 30px;

      .ht-title {
        padding-top: 20px;
        font-size: 24px;
        font-weight: 600;
        text-align: center;
        position: relative;

        &::before {
        content: " ";
        position: absolute;
        left: 50%;
        margin-left: -15px;
        bottom: -20px;
        width: 34px;
        height: 2px;
        background: #333333;
        border: 1px solid #333333;
        border-radius: 2px;
      }
      }
      .ht-desc{
        padding-top: 60px;
        line-height: 35px;
        text-align: justify;
        text-justify: distribute;
        

      }
    }
  }
}

.page-smxz-box {
  width: 800px;
  margin: 0 auto;
  height: 360px;
  margin-bottom: 70px;
  text-align: center;
  img {
    display: inline-block;
    width: 308px;
    height: 272px;
    margin-bottom: 20px;
  }

  .smxz-bottm-desc {
    font-size: 17px;
  }
}

.animate__animated {
  --animate-duration: 2s;
}

.animate__fadeInUp {
  --animate-duration: 2s;
}

.animate__flipInX {
  --animate-duration: 1s;
}
</style>
